// extracted by mini-css-extract-plugin
export default {"list":"LogoList-module--list--wmf5D","item":"LogoList-module--item--TAUAL"};